import { useNavigate } from "react-router-dom";

const ViewReadyMadeYogurt = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="main_title">
                <h1>View Ready Made Yogurt</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate(-1)}>Manage Ready Made Yoghurts</button> - View Ready Made Yogurt
                </p>
            </div>

            <div className="cards view_page">
                <div className="gap_p">
                    {/* Image */}
                    <div className="vew_img v2 no_radius w_100">
                        <h6>Image</h6>
                        <figure>
                            <img
                                src="/static/images/placeholder.png"
                                alt="Ready Made Yogurt"
                                className="product_image"
                            />
                        </figure>
                    </div>

                    <div className="w_33">
                        <h6>Name</h6>
                        <p>Strawberry Delight Yogurt</p>
                    </div>

                    <div className="w_33">
                        <h6>Quantity</h6>
                        <p>200 ml cup</p>
                    </div>

        
                    <div className="w_50">
                        <h6>Toppings</h6>
                        <p>Fresh Strawberries, Granola, Honey</p>
                    </div>
                    <div className="w_50">
                        <h6>Flavor</h6>
                        <p> Strawberry</p>
                    </div>

                    <div className="w_100">
                        <h6>Description</h6>
                        <p>
                            A creamy and refreshing yogurt made with real strawberries,
                            topped with granola and honey for a delightful crunch and flavor.
                        </p>
                    </div>

                    {/* Price */}
                    <div className="w_33">
                        <h6>Price</h6>
                        <p>$4.99</p>
                    </div>

                    {/* Tax */}
                    <div className="w_33">
                        <h6>Tax</h6>
                        <p>5% VAT</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewReadyMadeYogurt;